import { useState } from "react";
import { FaClipboardList, FaStickyNote } from "react-icons/fa";
import Modal from "../modal/modal";
import Dropdown from "../modal/dropdown";
import { dsrService } from "../services/dsrService";
import { toast } from "react-toastify";
import { DSRStatus, DSRStatusOptions } from "../../constants/constants";


const DSRModal = ({ onClose, onCheckOutSuccess, existingDSR = null, onSuccess }) => {
  const [form, setForm] = useState({
    report_text: existingDSR?.report_text || "",
    status: existingDSR?.status || DSRStatus.COMPLETED,
  });

  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    const errs = {};
    if (!form.report_text.trim()) errs.report_text = "Status report text is required.";

    if (Object.keys(errs).length > 0) {
      setFieldErrors(errs);
      setError("Please check the field errors below.");
      return;
    }
    setError("");
    setFieldErrors({});

    try {
      setSaving(true);

      const today = new Date().toISOString().split("T")[0];
      const payload = {
        date: existingDSR ? existingDSR.date : today,
        report_text: form.report_text,
        status: form.status,
      };

      if (existingDSR) {
        await dsrService.updateDSR(existingDSR.id, payload);
        toast.success("DSR updated successfully.");
      } else {
        await dsrService.createDSR(payload);
        toast.success("DSR submitted successfully.");
      }

      if (onSuccess) onSuccess();

      // On success, trigger check-out callback if provided
      if (onCheckOutSuccess) onCheckOutSuccess();

      if (!onCheckOutSuccess) onClose(); // close modal automatically if not handled by checkout
    } catch (err) {
      const respData = err.response?.data;
      const backendErrors = respData?.errors || (respData && typeof respData === "object" && !respData.message && !respData.detail ? respData : null);
      if (backendErrors && typeof backendErrors === "object") {
        const formatted = {};
        for (const key in backendErrors) {
          const val = backendErrors[key];
          formatted[key] = Array.isArray(val) ? val[0] : val;
        }
        setFieldErrors((prev) => ({ ...prev, ...formatted }));
        
        // If there's a non-field error (e.g. unique constraint failed), display it at the top
        if (formatted.non_field_errors) {
            setError(formatted.non_field_errors);
            setSaving(false);
            return;
        }
      }
      setError(respData?.message || respData?.detail || "Failed to submit DSR. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={existingDSR ? "Edit Daily Status Report" : "Submit Daily Status Report"}
      onClose={() => { if (!saving) onClose(); } }
      size="lg"
    >
      {error && <div className="form-error">{error}</div>}

      <div className="attendance-form-body">

        {/* STATUS */}
        <div className="form-section-card">
          <div className="section-title-premium"><FaClipboardList /> Report Status</div>
          <div className="full-row">
            <Dropdown
              options={DSRStatusOptions}
              value={form.status}
              placeholder="Status"
              onChange={(val) => {
                setForm({ ...form, status: val });
                if (fieldErrors.status) setFieldErrors({ ...fieldErrors, status: null });
              }}
            />
            {fieldErrors.status && <div className="field-error">{fieldErrors.status}</div>}
          </div>
        </div>

        {/* REPORT TEXT */}
        <div className="form-section-card">
          <div className="section-title-premium"><FaStickyNote /> Today's Report</div>
          <div className="full-row">
            <textarea
              className={fieldErrors.report_text ? "input-error" : ""}
              value={form.report_text}
              onChange={(e) => {
                setForm({ ...form, report_text: e.target.value });
                if (fieldErrors.report_text) setFieldErrors({ ...fieldErrors, report_text: null });
              }}
              rows={5}
              placeholder="e.g., Completed the frontend module for Check-out, but blocked on DB migration..."
            />
            {fieldErrors.report_text && <div className="field-error">{fieldErrors.report_text}</div>}
          </div>
        </div>

      </div>

      <div className="modal-footer" style={{ marginLeft: -26, marginRight: -26, marginBottom: -22, marginTop: 20 }}>
        <div className="modal-actions">
          <button className="primary" onClick={handleSubmit} disabled={saving}>
            {saving ? "Submitting..." : existingDSR ? "Update DSR" : onCheckOutSuccess ? "Submit & Check Out" : "Submit DSR"}
          </button>
          <button className="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DSRModal;